import React, { useState, useContext } from "react";
import Header from "../../header2/index-two";
import { AppContext } from "../../../services/AuthContext";
import axiosInstance from "../../../services/axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Footer2 } from "../../footer2";
import SettingsPageHeader from "./settingsPageHeader";

const InstructorChangePassword = () => {
  const { auth } = useContext(AppContext);
  const headers = auth.token
    ? {
        Authorization: `Bearer ${auth.token}`,
      }
    : "";
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (newPassword !== confirmPassword) {
      setErrorMessage("Yeni şifreler eşleşmiyor.");
      return;
    }

    try {
      const response = await axiosInstance.post(
        "users/UpdateUserPassword",
        {
          currentpassword: currentPassword,
          newpassword: newPassword,
        },
        {
          headers: headers,
        }
      );

      if (response.data && response.data.message) {
        toast.success(response.data.message);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error("Bir hata oluştu.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Bir hata oluştu.");
    }
  };

  return (
    <div className="main-wrapper bg-body-tertiary min-vh-100">
      <Header activeMenu={"Settings"} />
      <div className="container py-5 mt-5">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 mx-auto">
            <div className="bg-white rounded-4 shadow-sm p-4 mt-5">
              <h4 className="fw-semibold text-darkfume text-center mb-4 border-bottom pb-2">Şifre Değiştir</h4>
              <SettingsPageHeader />
              <form onSubmit={handleSubmit}>
                <div className="row g-3 mt-2">
                  <div className="col-12">
                    {errorMessage && (
                      <div className="alert alert-danger text-center">{errorMessage}</div>
                    )}
                    {successMessage && (
                      <div className="alert alert-success text-center">{successMessage}</div>
                    )}
                    <div className="input-block mb-3">
                      <label className="text-sm fw-semibold text-darkfume">Mevcut Şifre</label>
                      <input
                        type="password"
                        className="form-control"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="input-block mb-3">
                      <label className="text-sm fw-semibold text-darkfume">Yeni Şifre</label>
                      <input
                        type="password"
                        className="form-control"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="input-block mb-3">
                      <label className="text-sm fw-semibold text-darkfume">Yeni Şifreyi Tekrarla</label>
                      <input
                        type="password"
                        className="form-control"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="text-center mt-3">
                      <button className="btn btn-primary text-sm fw-semibold px-4 py-2" type="submit">
                        Şifreyi Sıfırla
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer2 />
      <ToastContainer />
    </div>
  );
};

export default InstructorChangePassword;
